/**
 * WhatsApp click-to-chat (https://wa.me/<number>?text=<message>) built from the Admin → Settings → Company "WhatsApp Number"
 * (`settings.whatsapp_number`). Nothing is assumed: with no number configured, or one that is not a full international number,
 * there is no link (the floating button simply isn't shown). The site's ordinary phone number is NOT reused — it may not be a
 * WhatsApp account.
 */
export const WHATSAPP_MESSAGE = "Hello Shingare Industries, I would like to enquire about your products.";

/** "+91 95949 45572" → "919594945572". "" when it isn't a full international number (country code + subscriber, 11–15 digits). */
export function whatsappDigits(raw) {
  const s = String(raw ?? "").trim();
  if (!s || !/^\+?[0-9\s().-]+$/.test(s)) return "";
  const digits = s.replace(/\D/g, "");
  if (digits.length < 11 || digits.length > 15 || digits.startsWith("0")) return "";
  return digits;
}

export function whatsappUrl(raw, message = WHATSAPP_MESSAGE) {
  const digits = whatsappDigits(raw);
  if (!digits) return "";
  return `https://wa.me/${digits}${message ? `?text=${encodeURIComponent(message)}` : ""}`;
}
